'use client';

import { useState, useEffect } from 'react';
import { TheAppBar } from './TheAppBar';
import { TheFooter } from './TheFooter';
import { useAppShell } from '@/hooks/useAppShell';
import { AnimatedSailboat } from '@/components/sea/AnimatedSailboat';
import { AnimatedYawl } from '@/components/sea/AnimatedYawl';
import { LanguageSuggestionBanner } from '@/components/LanguageSuggestionBanner';
import { TwoFactorPromotionBanner } from '@/components/TwoFactorPromotionBanner';
import ContentContainer from '@/components/ContentContainer';
import { ContextRedirectGuard } from '@/components/ContextRedirectGuard';

export function AppShell({ children }: { children: React.ReactNode }) {
  const { layoutClasses } = useAppShell();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  return (
    <div
      className={`${layoutClasses} flex flex-col min-h-screen relative overflow-hidden bg-white dark:bg-slate-950`}
    >
      {/* Ocean Background Animation */}
      {mounted && (
        <div className="ocean-bg">
          <div className="wave"></div>
          <div className="wave"></div>
          <div className="wave"></div>
        </div>
      )}

      {/* Decorative Sailboat - Floating in background bottom right */}
      {mounted && (
        <div className="fixed bottom-[15%] right-[5%] z-[1] pointer-events-none">
          <AnimatedSailboat size={200} color="#006994" duration={6} />
        </div>
      )}

      {/* Decorative Yawl - Floating slightly left of center, further back */}
      {mounted && (
        <div className="fixed bottom-[25%] left-[30%] z-[1] pointer-events-none">
          <AnimatedYawl size={160} color="#006994" duration={7} />
        </div>
      )}

      {/* Decorative Yawl - Floating far right, smaller */}
      {mounted && (
        <div className="fixed bottom-[35%] right-[15%] z-[1] pointer-events-none">
          <AnimatedYawl size={100} color="#006994" duration={9} />
        </div>
      )}

      {/* Decorative Sailboat - Smaller, far left */}
      {mounted && (
        <div className="fixed bottom-[20%] left-[2%] z-[1] pointer-events-none">
          <AnimatedSailboat size={120} color="#006994" duration={8} />
        </div>
      )}

      <ContextRedirectGuard />
      <TheAppBar />
      <LanguageSuggestionBanner />
      <TwoFactorPromotionBanner />
      <main className="cf-layout-main flex-1 flex flex-col relative z-10 bg-transparent min-w-0 overflow-x-hidden">
        <ContentContainer className="cf-content-wrapper flex-1 min-w-0">
          {children}
        </ContentContainer>
      </main>
      <TheFooter />
    </div>
  );
}
